import { useState } from "react";
import { Users, FileText, Link, ShieldCheck } from "lucide-react";
import AdminUsers from "./AdminUsers";
import ManagementReview from "./ManagementReview";
import ExternalTokens from "./ExternalTokens";
import DriveConnect from "./DriveConnect";

const TABS = [
  { key: "users", label: "Usuarios", icon: Users },
  { key: "review", label: "Revisión por la Dirección", icon: FileText },
  { key: "external", label: "Accesos Externos", icon: Link },
  { key: "drive", label: "Google Drive", icon: ShieldCheck },
];

export default function Admin() {
  const [tab, setTab] = useState("users");
  return (
    <div data-testid="admin-module">
      <h1 className="card-h1">Administración del Tenant</h1>
      <div className="tabs-bar">
        {TABS.map((t) => {
          const Icon = t.icon;
          return (
            <button key={t.key} className={`tab ${tab === t.key ? "active" : ""}`} onClick={() => setTab(t.key)} data-testid={`admin-tab-${t.key}`}>
              <Icon size={14} /> {t.label}
            </button>
          );
        })}
      </div>
      {tab === "users" && <AdminUsers />}
      {tab === "review" && <ManagementReview />}
      {tab === "external" && <ExternalTokens />}
      {tab === "drive" && <DriveConnect />}
    </div>
  );
}
